module.exports = new __parcel__URL__("gate.512dbc57.svg").toString();